/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Action_View_NotificationsInputs */

const en_notifications_action_view_notifications = /** @type {(inputs: Notifications_Action_View_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View notifications`)
};

const pt_br2_notifications_action_view_notifications = /** @type {(inputs: Notifications_Action_View_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver notificações`)
};

/**
* | output |
* | --- |
* | "View notifications" |
*
* @param {Notifications_Action_View_NotificationsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_action_view_notifications = /** @type {((inputs?: Notifications_Action_View_NotificationsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Action_View_NotificationsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_action_view_notifications(inputs)
	return pt_br2_notifications_action_view_notifications(inputs)
});